import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CheckCircle, Star, ChevronDown, ArrowRight, Play,
  Zap, Shield, Clock
} from "lucide-react";

const HERO_IMAGE = "https://images.pexels.com/photos/6388373/pexels-photo-6388373.jpeg";

export default function HeroSection() {
  const navigate = useNavigate();
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={HERO_IMAGE} alt="FitSmith gym" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/85 to-[#0a0a0a]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-[#0a0a0a]/30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        <div className="max-w-2xl">
          <div className="flex flex-wrap gap-3 mb-8 animate-slideUp">
            {["Praktisch", "Doelgericht", "Wetenschappelijk onderbouwd"].map((badge) => (
              <span key={badge} className="trust-badge">
                <CheckCircle size={12} className="text-[#C9A84C]" /> {badge}
              </span>
            ))}
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 animate-slideUp animation-delay-100">
            Transformeer je lijf.{" "}
            <span className="text-gradient">Bouw aan de beste versie van jezelf.</span>
          </h1>
          <p className="text-base sm:text-lg text-zinc-300 leading-relaxed mb-8 max-w-xl animate-slideUp animation-delay-200">
            FitSmith helpt je sterker, fitter en zelfverzekerder worden met doordachte trainingsschema's en een complete online cursus.
          </p>
          <div className="flex flex-wrap gap-4 mb-8 animate-slideUp animation-delay-300">
            <button onClick={() => scrollTo("#aanbod")} data-testid="hero-primary-cta"
              className="btn-gold px-7 py-3.5 font-bold text-sm uppercase tracking-wide">
              Bekijk het aanbod
            </button>
            <button onClick={() => navigate("/registreren")} data-testid="hero-secondary-cta"
              className="btn-outline px-7 py-3.5 font-bold text-sm uppercase tracking-wide flex items-center gap-2">
              <Play size={16} className="fill-white" /> Start nu
            </button>
          </div>
          <div className="flex flex-wrap gap-5 mb-10 animate-slideUp animation-delay-400">
            {[
              { icon: <Zap size={14} />, text: "Direct starten" },
              { icon: <Clock size={14} />, text: "Levenslange toegang" },
              { icon: <Shield size={14} />, text: "Getest in de praktijk" },
            ].map(({ icon, text }) => (
              <div key={text} className="flex items-center gap-1.5 text-zinc-400 text-sm">
                <span className="text-[#C9A84C]">{icon}</span> {text}
              </div>
            ))}
          </div>
          <div className="flex items-center gap-3 animate-slideUp animation-delay-500">
            <div className="flex">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-[#C9A84C] fill-[#C9A84C]" />)}
            </div>
            <span className="text-white font-bold">4,8/5</span>
            <span className="text-zinc-400 text-sm">door 25+ cursisten</span>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown size={24} className="text-[#C9A84C]" />
      </div>
    </section>
  );
}
